import{Button as yt,InlineMessage as Lt,Input as wt,Row as At}from"@appcues/sonar";import{useForm as St}from"react-hook-form";import{Button as vt,Form as ht,InlineMessage as kt,Input as It}from"@appcues/sonar";import bt,{css as Nt}from"styled-components";var xt=Nt`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`,Be=bt(ht)`
  padding: var(--spacing-regular);
  padding-bottom: 0;

  ${vt} {
    flex: 1;
  }

  ${It} {
    flex: 2;
    ${xt};
  }

  ${kt} {
    padding-top: var(--spacing-small);
  }
`;import{jsx as ue,jsxs as Fe}from"react/jsx-runtime";var D=({user:e,isSpoofing:t,onSpoof:i})=>{let{register:n,handleSubmit:a,formState:{errors:s,isSubmitting:r},setError:c}=St(),{isAdmin:m}=e!=null?e:{};return!m||t?null:Fe(Be,{onSubmit:a(async({accountId:p})=>{try{await i(p)}catch(h){c("accountId",{message:"Failed to spoof"})}}),children:[Fe(At,{xAlign:"center",spacing:"small",children:[ue(wt,{id:"accountId",placeholder:"Account ID",type:"number",...n("accountId",{required:"Can't be empty"})}),ue(yt,{type:"submit",disabled:r,children:"Spoof"})]}),s.accountId&&ue(Lt,{variant:"error",children:s.accountId.message})]})};import We from"styled-components";var De=We.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
  padding-top: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
`,$e=We.span`
  align-items: center;
  color: var(--color-blurple-600);
  display: flex;
  font-size: var(--icon-size-large);
  justify-content: center;

  svg {
    height: 30px;
    width: 24px;

    path {
      fill: currentColor;
    }
  }
`;import{jsx as $}from"react/jsx-runtime";var O=({size:e="regular"})=>$(De,{$size:e,children:$("a",{href:"/",children:$($e,{children:$("svg",{viewBox:"0 0 1600 2000",xmlns:"http://www.w3.org/2000/svg",role:"img","aria-label":"Appcues logo",children:$("path",{d:"M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"})})})})});import H from"styled-components";import{Stack as Tt}from"@appcues/sonar";var Oe=H(Tt).attrs({spacing:"none"})`
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  width: 240px;
  background-color: var(--color-neutral-0);
  border-right: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  /*
  * This z-index is chosen because it is bigger than the biggest z-index currently
  * found in studio excluding Modals, which is in the studio classic TabsRoot
  * component (z-index: 3000). We will look at standardizing our use of z-index in
  * studio in the future.
  */
  z-index: 4000;
`,He=H.div`
  overflow-y: auto;
  flex-grow: 1;
`,ze=H.nav`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`,Ue=H.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
  padding-bottom: var(--spacing-small);
  padding-top: var(--spacing-small);
  list-style-type: none;
`,X=H.div`
  width: 18px;
  height: 14px;
`;import{Icon as Pt,Row as Ct,Text as Mt}from"@appcues/sonar";import Ge from"styled-components";import{Text as _e}from"@appcues/sonar";var Y=Ge.li`
  a {
    height: 40px;
    display: flex;
    text-decoration: none;
    padding-left: var(--spacing-large);
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }
    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${_e} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ve=Ge.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${_e} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as J,jsxs as Rt}from"react/jsx-runtime";var Ke=({children:e,icon:t,iconElement:i,NavLink:n,to:a,end:s,isActive:r,className:c,external:m=!1,isSubItem:d=!1,...p})=>J(Y,{className:c,children:J(m||!n?"a":n,{isSubItem:d,to:a,end:s,className:r?"active":"",...p,children:Rt(Ct,{spacing:"small",yAlign:"center",children:[i&&i,t&&J(Pt,{icon:t,colorToken:"foreground-secondary",size:"small"}),J(Mt,{colorToken:"foreground-primary",children:e})]})})});import{useState as Dt}from"react";import{Accordion as $t,Row as Ot}from"@appcues/sonar";import{Accordion as Q,Icon as Wt}from"@appcues/sonar";import z,{css as Ze}from"styled-components";import fe,{css as Et}from"styled-components";import{Row as Bt,Text as qe}from"@appcues/sonar";var Ft=Et`
  padding: 0 var(--spacing-regular);
`,Z=fe.div`
  a {
    height: ${({variant:e="regular"})=>e==="regular"?"40px":"64px"};
    display: flex;
    text-decoration: none;
    padding: 0 var(--spacing-large);
    ${({isSubItem:e})=>e&&Ft}
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }

    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${qe} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Xe=fe(Bt)`
  max-width: 100%;
`,Ye=fe(qe).attrs({forwardedAs:"span"})`
  flex: 1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;var ve=Ze`
  fill: var(--color-blurple-600);
`,he=z(Wt)`
  display: block;
  // 18px is used so that the accordion icon aligns with the other nav item icons
  width: 18px;

  path {
    transition: fill 0.3s ease;
    // The active state is determined programatically because when the accordion is closed the active list item is reomved from the DOM
    ${({$isActive:e})=>e&&ve}
  }
`,Je=Ze`
  background-color: var(--color-neutral-50);
  border-radius: var(--border-radius-small);
`,Qe=z(Q.Header)`
  height: 40px;
  display: flex;
  // The Sonar Accordion.Header has some padding that we need to override so that the correct hover background can be applied
  padding: 0;
  font-weight: var(--font-weight-regular);
  transition: background-color 0.3s ease;

  :hover {
    ${Je};

    ${he} {
      path {
        ${ve};
      }
    }
  }

  /* Shows accordion header as active if collapsed */
  &[data-state='closed'] {
    ${({$isActive:e})=>e&&Je};
  }
`,je=z(Q.Trigger)`
  color: var(--foreground-primary);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
`,eo=z(Q.Content)`
  p {
    // Padding of 26px is required so that the accordion content aligns correctly with the other nav item text
    padding-left: 26px;
  }

  // We don't want padding on the last list item because a 4px space is already provided by the flex gap
  li {
    &:not(:last-child) {
      padding-bottom: var(--spacing-x-small);
    }
  }
`,oo=z(Q.Item)`
  // These styles create a gap between the trigger and the content when the accordion is expanded, but
  // the gap is removed when the accordion is collapsed
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);

  // This selector is used to apply the blurple fill to the accordion icon when one of it's children is hovered
  &:has(div > li > a:hover) {
    div > svg > path {
      ${ve}
    }
  }

  ${Z} {
    margin-left: var(--spacing-x-large);
    margin-right: var(--spacing-small);
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: var(--color-neutral-300);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;import{jsx as U,jsxs as no}from"react/jsx-runtime";var Ht="@navigation/accordion_",to={getAccordionKey(e){return`${Ht}${e}`},getAccordionValue(e){let t=this.getAccordionKey(e);return localStorage.getItem(t)},setAccordionValue(e,t){let i=this.getAccordionKey(e);Boolean(t)?localStorage.setItem(i,t):localStorage.removeItem(i)}},io=({children:e,text:t,icon:i,isActive:n})=>{let a=()=>{if(n)return t;let m=to.getAccordionValue(t);if(m)return m},[s,r]=Dt(a()),c=m=>{r(m),to.setAccordionValue(t,m)};return U($t.Root,{collapsible:!0,value:s,onValueChange:c,type:"single",$unstyled:!0,children:no(oo,{value:t,children:[U(Qe,{$isActive:n,children:U(je,{children:no(Ot,{spacing:"small",yAlign:"center",children:[U(he,{icon:i,colorToken:"color-neutral-700",size:"small",$isActive:n}),t]})})}),U(eo,{children:e})]})})};import{jsx as ro}from"react/jsx-runtime";var ao=({children:e,isActive:t,onClick:i})=>ro(Y,{children:ro(Ve,{onClick:i,className:t?"active":"",children:e})});import{Icon as so,Row as lo,Text as zt}from"@appcues/sonar";import{faChevronRight as Ut}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{jsx as j,jsxs as po}from"react/jsx-runtime";var co=({icon:e,label:t})=>po(lo,{xAlign:"space-between",yAlign:"center",children:[po(lo,{spacing:"small",yAlign:"center",children:[j(X,{children:j(so,{icon:e,colorToken:"foreground-secondary",size:"small"})}),j(zt,{colorToken:"foreground-primary",forwardedAs:"span",children:t})]}),j(so,{icon:Ut,colorToken:"foreground-secondary",size:"small"})]});import{forwardRef as Gt}from"react";import{Icon as _t,NavigationMenu as Vt}from"@appcues/sonar";import{jsx as R,jsxs as Kt}from"react/jsx-runtime";var mo=Gt(({children:e,icon:t,iconElement:i,NavLink:n,to:a,end:s,isActive:r,external:c=!1,isSubItem:m,variant:d="regular",title:p,...h},v)=>{let k=c||!n?"a":n;return R(Z,{isSubItem:m,variant:d,className:"accordion-link-item",children:R(Vt.Link,{asChild:!0,children:R(k,{ref:v,to:a,end:s,className:r?"active":"",...h,children:Kt(Xe,{fluid:!0,spacing:"small",yAlign:"center",children:[i&&i,t&&R(X,{children:R(_t,{icon:t,colorToken:"foreground-secondary",size:"small"})}),R(Ye,{colorToken:"foreground-primary",title:p||"",children:e})]})})})})});import{NavigationMenu as Yt}from"@appcues/sonar";import qt from"styled-components";import{Text as Xt}from"@appcues/sonar";var go=qt.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;
  border: 0;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Xt} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as uo}from"react/jsx-runtime";var fo=({children:e,onClick:t,className:i})=>uo(Yt.Link,{asChild:!0,children:uo(go,{onClick:t,className:i,children:e})});var o={Wrapper:Oe,ScrollContainer:He,NavList:Ue,Nav:ze,NavItem:Ke,NavButton:ao,NavAccordion:io,NavTrigger:co,LinkItem:mo,ButtonItem:fo};import{useEffect as ke}from"react";function vo({user:e,account:t,cannyAppId:i,isOpen:n}){ke(()=>{if(window.Canny&&t&&e){let{id:a,isTrial:s,tier:r,stripePlanId:c}=t,{fullname:m,email:d,id:p,job:h,crxVersion:v}=e;window.Canny("identify",{appID:i,user:{email:d,name:m||"anonymous",id:p,customFields:{job:h,crxVersion:v},companies:[{customFields:{isTrial:s,tier:r,stripePlanId:c},id:a,name:a}]}})}},[t,i,e]),ke(()=>{!n&&window.Canny&&window.Canny("closeChangelog")},[n]),ke(()=>{new MutationObserver(()=>{if(document.querySelector("[data-canny-changelog]"))try{window.Canny("initChangelog",{appID:i,position:"right",align:"bottom"})}catch(r){}}).observe(document.body,{childList:!0,subtree:!0})},[i])}import{Icon as rn,Row as an,Tooltip as sn}from"@appcues/sonar";import{faScrewdriverWrench as ln}from"@fortawesome/pro-solid-svg-icons/faScrewdriverWrench";import _ from"styled-components";import{Button as tn,Stack as nn,NavigationMenu as yo}from"@appcues/sonar";import{Progress as en}from"@appcues/sonar";import on from"pluralize";import{differenceInDays as Jt}from"date-fns";var Ie=(e,t)=>Jt(e,t),ho=e=>new Intl.DateTimeFormat(void 0,{year:"numeric",month:"short",day:"2-digit"}).format(e);var be=(e,t)=>!((e==null?void 0:e.stripePlanId)||(t==null?void 0:t.isExpired));import G from"styled-components";import{Skeleton as Zt}from"@studio/legacy-components";import{Button as Qt,Tooltip as jt}from"@appcues/sonar";var ko=G.div`
  text-align: center;
  gap: 8px;
  padding: 16px 24px 0 24px;
  display: flex;
  flex-direction: column;

  ${Zt} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${Qt} {
    --link-color: #ffffff;
    --link-text-decoration: none;
    --link-visited-color: #ffffff;
  }
`,Io=G.div`
  font-weight: 700;
  color: rgb(57, 68, 85);
  font-size: 14px;
`,bo=G.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
`,No=G.div`
  width: 180px;
  white-space: pre-wrap;
  font-size: 0.75rem;
`,xo=G(jt)`
  width: 100%;
`;import{jsx as ee,jsxs as Ne}from"react/jsx-runtime";var xe=({account:e={},trialStatus:t={},className:i,Link:n})=>{let{createdAt:a,expirationDate:s,isWebInstalled:r,lengthDays:c}=t;if(!be(e,t)||!a||!s)return null;let d=Ie(new Date(s),new Date(a))+1,p=Ie(new Date(s),new Date)+1,v=(d-p)/d,k=Math.round(v*100),x=p>7?"default":(p>3,"error"),L=Ne(No,{children:["Trial expires on ",ho(new Date(s)),"."," ",r?"":`Install the Appcues SDK to extend your trial another ${c} days.`]});return Ne(ko,{className:i,children:[ee(xo,{placement:"right",content:L,children:Ne(bo,{children:[ee(Io,{children:`${p} ${on("day",p)} left in trial`}),ee(en,{value:k,max:100,variant:x})]})}),ee(n,{to:"/subscription",children:"Upgrade now"})]})};var oe=_(yo.Trigger)`
  height: 40px;
`,Lo=_(nn).attrs({spacing:"large"})`
  padding: var(--spacing-large);
`,wo=_(xe)`
  padding: 0;
`,ye=_(tn)`
  width: 100%;
  text-decoration: none;
`,E=_(yo.Content)`
  position: absolute;
  transform: translateY(-40px);
  left: 100%;
  margin-left: var(--spacing-x-small);
  background-color: var(--color-neutral-0);
  border-radius: var(--border-radius-small);
  gap: var(--spacing-x-small);
  padding: var(--spacing-small) var(--spacing-x-small);
  box-shadow: var(--elevation-300);
  transform: translateY(-40px);
  width: 200px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;import{jsx as V,jsxs as Ao}from"react/jsx-runtime";var So=({NavLink:e,isInstalled:t,account:i,trialStatus:n})=>Ao(Lo,{children:[t?null:V(sn,{size:"regular",content:"In order to publish live experiences to your users, you'll have to install Appcues directly into your codebase. Don't worry...it's super easy. Click here to learn how!",children:V(ye,{variant:"secondary",fluid:!0,forwardedAs:e,to:"/settings/installation",children:Ao(an,{spacing:"small",yAlign:"center",children:[V(rn,{icon:ln}),"Install"]})})}),V(wo,{account:i,trialStatus:n,Link:a=>V(ye,{variant:"tertiary",forwardedAs:e,...a})})]});import{useState as Bo}from"react";import{faGear as gn}from"@fortawesome/pro-solid-svg-icons/faGear";import{faChevronRight as dn}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{faExternalLink as un}from"@fortawesome/pro-solid-svg-icons/faExternalLink";import{faArrowRightFromBracket as fn}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{Icon as ne,Row as we,Stack as vn,Text as Ae,NavigationMenu as ie}from"@appcues/sonar";import A from"styled-components";import{Text as To,Stack as pn,Row as cn}from"@appcues/sonar";import{Separator as mn}from"@radix-ui/react-separator";var Po=A(pn).attrs({spacing:"x-small"})`
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,Co=A(E)`
  transform: translateY(-105%);
  width: 237px;
`,Mo=A(cn)`
  max-width: calc(100% - var(--spacing-large));
`,te=A(To).attrs({colorToken:"foreground-primary",forwardedAs:"span",weight:"bold"})`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`,Ro=A.div`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  cursor: pointer;
`,Eo=A(To)`
  padding-left: 22px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`,Le=A(mn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
`;import{jsx as f,jsxs as w}from"react/jsx-runtime";var Fo=({NavLink:e,onLogout:t,user:{email:i,fullName:n}={},companyName:a,accountsCount:s})=>{let r=a||i||"",[c,m]=Bo(),[d,p]=Bo(!1),h=v=>{c&&!d&&(v.preventDefault(),p(!0)),c&&d&&p(!1)};return f(ie.Root,{orientation:"vertical",value:c,onValueChange:v=>{m(v),v||p(!1)},children:f(ie.List,{children:w(ie.Item,{value:"account-menu",children:[f(ie.Trigger,{onClick:h,children:w(Po,{children:[w(we,{xAlign:"space-between",yAlign:"center",children:[w(Mo,{spacing:"small",yAlign:"center",children:[f(ne,{icon:gn,colorToken:"foreground-secondary",size:"small"}),f(te,{title:r,children:r})]}),f(ne,{icon:dn,colorToken:"foreground-secondary",size:"small"})]}),n&&f(Eo,{title:n,size:"small",children:n})]})}),f(Co,{children:w("ul",{children:[s>1?f(o.LinkItem,{isSubItem:!0,variant:"tall",NavLink:e,to:"/accounts-v2",children:w(vn,{spacing:"x-small",children:[f(te,{title:r,children:r}),f(Ae,{size:"small",children:"Switch Accounts"})]})}):f(Ro,{children:f(te,{title:r,children:r})}),f(Le,{}),f(o.LinkItem,{isSubItem:!0,NavLink:e,to:"/settings/account",children:"Settings"}),f(o.LinkItem,{external:!0,isSubItem:!0,"data-canny-link":!0,href:"https://feedback.appcues.com/product-feedback?sort=top",target:"_blank",children:"Suggest a feature"}),f(o.LinkItem,{external:!0,isSubItem:!0,href:"https://status.appcues.com",target:"_blank",children:w(we,{xAlign:"space-between",yAlign:"center",children:[f(Ae,{forwardedAs:"span",children:"Appcues status"}),f(ne,{icon:un,colorToken:"foreground-link"})]})}),f(Le,{}),f("li",{children:f(o.ButtonItem,{onClick:t,children:w(we,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[f(Ae,{colorToken:"foreground-primary",forwardedAs:"span",children:"Sign out"}),f(ne,{colorToken:"foreground-secondary",icon:fn})]})})})]})})]})})})};import B from"styled-components";import{NavigationMenu as Wo,Row as hn}from"@appcues/sonar";import{Separator as kn}from"@radix-ui/react-separator";var F=B(kn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
  padding: 0.1px 0 0 0;
`,re=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  height: 100%;
  overflow-y: auto;
`,Do=B(Wo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & ul {
    list-style-type: none;
  }
`,$o=B(Wo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;

  & ul {
    list-style-type: none;
  }
`,K=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`,Oo=B(hn).attrs({spacing:"x-small",yAlign:"center",xAlign:"center"})`
  background: var(--color-neutral-100);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-x-small);
  color: var(--foreground-secondary);

  svg path {
    fill: var(--foreground-secondary) !important;
  }
`;import{useState as Ko}from"react";import{NavigationMenu as le}from"@appcues/sonar";import{faFolderMagnifyingGlass as Rn}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as En}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as Bn}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faUsers as zo}from"@fortawesome/pro-solid-svg-icons/faUsers";import{faArrowsTurnToDots as In}from"@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots";import{faMessages as bn}from"@fortawesome/pro-solid-svg-icons/faMessages";import{faMap as Uo}from"@fortawesome/pro-solid-svg-icons/faMap";import{faThumbtack as Nn}from"@fortawesome/pro-solid-svg-icons/faThumbtack";import{faCheckCircle as xn}from"@fortawesome/pro-solid-svg-icons/faCheckCircle";import{faComment as yn}from"@fortawesome/pro-solid-svg-icons/faComment";import{faRocket as Ln}from"@fortawesome/pro-solid-svg-icons/faRocket";import{faChartColumn as Go}from"@fortawesome/pro-solid-svg-icons/faChartColumn";import{faBullseye as wn}from"@fortawesome/pro-solid-svg-icons/faBullseye";import{faChartPieSimple as An}from"@fortawesome/pro-solid-svg-icons/faChartPieSimple";import{faBuildings as Sn}from"@fortawesome/pro-solid-svg-icons/faBuildings";import{faTh as Tn}from"@fortawesome/pro-solid-svg-icons/faTh";import{faRectangleCode as Pn}from"@fortawesome/pro-solid-svg-icons/faRectangleCode";import{NavigationMenu as ae}from"@appcues/sonar";import{faEnvelopeOpen as Cn}from"@fortawesome/pro-solid-svg-icons";import{jsx as Ho}from"react/jsx-runtime";var W=()=>Ho("svg",{width:"18",height:"16",viewBox:"0 0 18 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:Ho("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",fill:"var(--foreground-secondary)"})});import{Fragment as Mn,jsx as u,jsxs as S}from"react/jsx-runtime";var _o={MESSAGING:[/^\/banners(\/.*)?$/,/^\/pins(\/.*)?$/,/^\/checklists(\/.*)?$/,/^\/nps(\/.*)?$/,/^\/nps-v2(\/.*)?$/,/^\/launchpads(\/.*)?$/,/^\/flows-v2(\/.*)?$/,/^\/embeds(\/.*)?$/],METRICS:[/^\/goals(\/.*)?$/,/^\/insights\/explorer(\/.*)?$/,/^\/insights\/charts(\/.*)?$/,/^\/email-performance(\/.*)?$/]},se=(e,t)=>t.some(i=>e.startsWith(i)),Vo=(e,t)=>t.some(i=>i.test(e)),Se=({NavLink:e,currentPath:t,featureFlags:i,handleClick:n})=>{let{hasLaunchpads:a,hasNps2:s,hasOpenBuilderFlows:r}=i,c=se(t,["/flows","/mobile","/experiments"]),m=Vo(t,[..._o.MESSAGING])||c,d=se(t,["/audience/segments","/segments"]),p=se(t,["/audience/users"]),h=se(t,["/audience"])||d||p,v=Vo(t,[..._o.METRICS]);return S(Mn,{children:[u(ae.Item,{children:u(o.LinkItem,{icon:In,NavLink:e,to:"/workflows",children:"Workflows"},"/workflows")}),S(ae.Item,{value:"messaging-menu",children:[u(oe,{className:m?"active":"",onClick:k=>n(k,"messaging-menu"),children:u(o.NavTrigger,{icon:bn,label:"Messaging"})}),u(E,{children:S("ul",{children:[u(o.LinkItem,{icon:Uo,NavLink:e,to:"/flows",isSubItem:!0,isActive:c,children:"Flows"},"/flows"),r&&u(o.LinkItem,{icon:Uo,NavLink:e,to:"/flows-v2",isSubItem:!0,children:"Flows 2.0"},"/flows-v2"),u(o.LinkItem,{icon:Pn,NavLink:e,to:"/embeds",isSubItem:!0,children:"Embeds"},"/embeds"),u(o.LinkItem,{iconElement:u(W,{}),NavLink:e,to:"/banners",isSubItem:!0,children:"Banners"},"/banners"),u(o.LinkItem,{icon:Nn,NavLink:e,to:"/pins",isSubItem:!0,children:"Pins"},"/pins"),u(o.LinkItem,{icon:xn,NavLink:e,to:"/checklists",isSubItem:!0,children:"Checklists"},"/checklists"),u(o.LinkItem,{icon:yn,NavLink:e,to:s?"/nps-v2":"/nps",isSubItem:!0,children:"NPS"},"/nps"),a&&u(o.LinkItem,{icon:Ln,NavLink:e,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]})})]}),S(ae.Item,{value:"audiences-menu",children:[u(oe,{className:h?"active":"",onClick:k=>n(k,"audiences-menu"),children:u(o.NavTrigger,{icon:zo,label:"Audiences"})}),u(E,{children:S("ul",{children:[u(o.LinkItem,{icon:An,NavLink:e,to:"/audience/segments-v2",isSubItem:!0,isActive:d,children:"Segments"},"/audience/segments-v2"),u(o.LinkItem,{icon:zo,NavLink:e,to:"/audience/users-v2",isSubItem:!0,isActive:p,children:"Users"},"/audience/users-v2"),u(o.LinkItem,{icon:Sn,NavLink:e,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]})})]}),S(ae.Item,{value:"metrics-menu",children:[u(oe,{className:v?"active":"",onClick:k=>n(k,"metrics-menu"),children:u(o.NavTrigger,{icon:Go,label:"Metrics"})}),u(E,{children:S("ul",{children:[u(o.LinkItem,{icon:wn,NavLink:e,to:"/goals",isSubItem:!0,children:"Goals"},"/goals"),u(o.LinkItem,{icon:Go,NavLink:e,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),u(o.LinkItem,{icon:Tn,NavLink:e,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),u(o.LinkItem,{icon:Cn,NavLink:e,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]})})]})]})};import{jsx as y,jsxs as Fn}from"react/jsx-runtime";function Te({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:a,actions:s,currentPath:r,hasLaunchpads:c,hasNps2:m,hasDevTools:d,hasOpenBuilderFlows:p}){let[h,v]=Ko(),[k,x]=Ko({}),L=(b,I)=>{h===I&&!k[I]&&(b.preventDefault(),x({[I]:!0})),h===I&&k[I]&&x({[I]:!1})},M=(b,I)=>{L(b,I)};return y(Do,{orientation:"vertical",value:h,onValueChange:b=>{v(b),b||x({})},children:y(le.List,{children:Fn(re,{children:[e&&s?s:null,t&&!i?null:y(le.Item,{children:y(o.LinkItem,{icon:En,NavLink:n,to:"/",end:a,children:"Overview"})}),y(K,{children:y(Se,{NavLink:n,currentPath:r,handleClick:(b,I)=>M(b,I),featureFlags:{hasLaunchpads:c,hasNps2:m,hasOpenBuilderFlows:p}})}),y(F,{}),y(le.Item,{children:y(o.LinkItem,{icon:Rn,NavLink:n,to:"/folders",children:"Folders"})}),d&&y(le.Item,{children:y(o.LinkItem,{icon:Bn,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{Icon as Wn,NavigationMenu as Pe,Row as Dn}from"@appcues/sonar";import{trackEvent as $n}from"@studio/analytics";import{faArrowsTurnToDots as On,faMessages as Hn,faMap as qo,faThumbtack as zn,faCheckCircle as Un,faComment as Gn,faChartColumn as Xo,faBullseye as _n,faEnvelopeOpen as Vn,faTh as Kn,faUsers as Yo,faChartPieSimple as qn,faBuildings as Xn,faRocket as Yn,faChartLine as Jn,faFlask as Zn,faRectangleCode as Qn,faLightbulb as jn,faBarsFilter as ei}from"@fortawesome/pro-solid-svg-icons";import{faFolderMagnifyingGlass as oi}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as ti}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as ni}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faSparkles as ii}from"@fortawesome/pro-regular-svg-icons";import{jsx as l,jsxs as T}from"react/jsx-runtime";var ri=["/flows","/pins","/banners","/checklists","/nps","/embeds"],ai=["/flows","/flows-v2"],si=["/goals","/insights/explorer","/insights/charts","/insights/funnels","/email-performance"],li=["/audience/segments-v2","/audience/users-v2","/audience/accounts"],pe=(e,t)=>e.some(i=>t.startsWith(i));function Ce({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:a,actions:s,currentPath:r,hasNps2:c,hasDevTools:m,hasAiInsights:d,hasFunnels:p,hasOpenBuilderFlows:h}){let v=pe(ri,r),k=pe(si,r),x=pe(li,r),L=pe(ai,r);return l($o,{orientation:"vertical",children:l(Pe.List,{children:T(re,{children:[e&&s?s:null,T(K,{children:[t&&!i?null:l(o.LinkItem,{icon:ti,NavLink:n,to:"/",end:a,children:"Overview"}),d&&l(o.LinkItem,{NavLink:n,to:"/insights-feed",icon:jn,onClick:()=>{$n({name:"nav_click",properties:{navItemID:"insights-feed",navItemName:"Insights"}})},children:T(Dn,{xAlign:"space-between",yAlign:"center",spacing:"small",children:["Insights",l(Oo,{children:l(Wn,{icon:ii,size:"small"})})]})})]}),T(K,{children:[T(o.NavAccordion,{isActive:v,text:"Experiences",icon:Hn,children:[l(o.LinkItem,{NavLink:n,to:"/flows",icon:qo,isActive:L,isSubItem:!0,children:"Flows"},"/flows"),h&&l(o.LinkItem,{icon:qo,NavLink:n,to:"/flows-v2",isSubItem:!0,title:"Flows 2.0",children:"Flows 2.0"},"/flows-v2"),l(o.LinkItem,{icon:Qn,NavLink:n,to:"/embeds",isSubItem:!0,title:"Embeds",children:"Embeds"},"/embeds"),l(o.LinkItem,{NavLink:n,to:"/pins",icon:zn,isSubItem:!0,children:"Pins"},"/pins"),l(o.LinkItem,{NavLink:n,to:"/banners",iconElement:l(W,{}),isSubItem:!0,children:"Banners"},"/banners"),l(o.LinkItem,{NavLink:n,to:"/checklists",icon:Un,isSubItem:!0,children:"Checklists"},"/checklists"),l(o.LinkItem,{NavLink:n,to:c?"/nps-v2":"/nps",icon:Gn,isSubItem:!0,children:"NPS"},"/nps"),l(o.LinkItem,{icon:Yn,NavLink:n,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]}),T(o.NavAccordion,{isActive:k,text:"Metrics",icon:Xo,children:[l(o.LinkItem,{NavLink:n,to:"/goals",icon:_n,isSubItem:!0,children:"Goals"},"/goals"),l(o.LinkItem,{icon:Xo,NavLink:n,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),l(o.LinkItem,{icon:Kn,NavLink:n,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),p&&l(o.LinkItem,{icon:ei,NavLink:n,to:"/insights/funnels",isSubItem:!0,children:"Funnels"},"/insights/funnels"),l(o.LinkItem,{NavLink:n,to:"/experiments",icon:Zn,isSubItem:!0,children:"Experiments"},"/experiments"),l(o.LinkItem,{NavLink:n,to:"/performance",icon:Jn,isSubItem:!0,children:"Flow Performance"},"/performance"),l(o.LinkItem,{title:"Email Performance",icon:Vn,NavLink:n,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]}),T(o.NavAccordion,{isActive:x,text:"Audiences",icon:Yo,children:[l(o.LinkItem,{icon:qn,NavLink:n,to:"/audience/segments-v2",isSubItem:!0,children:"Segments"},"/audience/segments-v2"),l(o.LinkItem,{icon:Yo,NavLink:n,to:"/audience/users-v2",isSubItem:!0,children:"Users"},"/audience/users-v2"),l(o.LinkItem,{icon:Xn,NavLink:n,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]}),l(o.LinkItem,{NavLink:n,to:"/workflows",icon:On,children:"Workflows"},"/workflows")]}),l(F,{}),l(Pe.Item,{children:l(o.LinkItem,{icon:oi,NavLink:n,to:"/folders",children:"Folders"})}),m&&l(Pe.Item,{children:l(o.LinkItem,{icon:ni,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{jsx as P,jsxs as pi}from"react/jsx-runtime";var Jo=({user:e,account:t,accountsCount:i,onSpoof:n,onLogout:a,isSpoofing:s,NavLink:r,featureFlags:c,matchExactRoutes:m,isInstalled:d,trialStatus:p,cannyAppId:h,currentPath:v,actions:k})=>{let{hasDevTools:x,hasLaunchpads:L,hasOverviewRedirect:M,hasAiAssistant:b,hasNps2:I,hasNav2025:ge,hasAiInsights:de,hasFunnels:N,hasOpenBuilderFlows:Ee}=c;return vo({user:e,account:t,cannyAppId:h,isOpen:!1}),pi(o.Wrapper,{children:[P(D,{user:e,onSpoof:n,isSpoofing:s}),P(O,{size:"large"}),ge?P(Ce,{hasDevTools:x,hasOverviewRedirect:M,isInstalled:d,NavLink:r,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:I,hasAiAssistant:b,hasAiInsights:de,hasFunnels:N,hasOpenBuilderFlows:Ee}):P(Te,{hasDevTools:x,hasLaunchpads:L,hasOverviewRedirect:M,isInstalled:d,NavLink:r,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:I,hasAiAssistant:b,hasOpenBuilderFlows:Ee}),P(So,{NavLink:r,isInstalled:d,account:t,trialStatus:p}),P(F,{}),P(Fo,{user:e,companyName:t==null?void 0:t.name,NavLink:r,accountsCount:i,onLogout:a})]})};import{faCircleUser as ki}from"@fortawesome/pro-solid-svg-icons/faCircleUser";import{faPeopleGroup as Ii}from"@fortawesome/pro-solid-svg-icons/faPeopleGroup";import{faCreditCard as bi}from"@fortawesome/pro-regular-svg-icons/faCreditCard";import{faLaptopMobile as Ni}from"@fortawesome/pro-solid-svg-icons/faLaptopMobile";import{faPaperPlane as xi}from"@fortawesome/pro-solid-svg-icons/faPaperPlane";import{faPlug as yi}from"@fortawesome/pro-solid-svg-icons/faPlug";import{faDatabase as Li}from"@fortawesome/pro-solid-svg-icons/faDatabase";import{faGlobe as wi}from"@fortawesome/pro-solid-svg-icons/faGlobe";import{faSparkles as Ai}from"@fortawesome/pro-solid-svg-icons/faSparkles";import{faArrowRightFromBracket as Si}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{faPalette as Ti}from"@fortawesome/pro-solid-svg-icons/faPalette";import{Icon as Pi,NavigationMenu as ot,Row as Ci,Text as Mi}from"@appcues/sonar";import ci from"styled-components";import{Button as mi,Icon as gi,Text as di,Tooltip as ui}from"@appcues/sonar";import{faChevronLeft as fi}from"@fortawesome/pro-solid-svg-icons/faChevronLeft";import{jsx as q}from"react/jsx-runtime";var vi=ci.div`
  justify-self: end;
`,Zo=({onClick:e})=>q(vi,{children:q(ui,{content:q(di,{size:"small",lineHeight:"large",colorToken:"foreground-tooltip",children:"Exit settings"}),placement:"bottom",children:q(mi,{title:"back link",variant:"tertiary",iconOnly:!0,onClick:e,children:q(gi,{icon:fi})})})});import{Text as hi}from"@appcues/sonar";import Me from"styled-components";var Qo=Me(hi)`
  padding-left: var(--spacing-large);
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,jo=Me.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
`,et=Me.div`
  padding-bottom: var(--spacing-small);
`;import{jsx as g,jsxs as C}from"react/jsx-runtime";var Ri=new Set(["/settings/integrations","/webhooks","/settings/keys","/integrations/webhooks","/integrations/connections"]),Ei=new Set(["/settings/events","/settings/properties","/settings/properties/users","/settings/properties/groups"]),Bi=["/settings/themes",/^\/themes(\/.*)?$/],Fi=["/settings/installation",/apps\/[^/]+$/],Wi=["/settings/emails/senders",/\/settings\/emails\/suppression-lists\/[^/]+$/],tt=({NavLink:e,featureFlags:t,currentPath:i,user:n,onSpoof:a,isSpoofing:s,onClickBackArrow:r,onClickLogout:c,hasLocalizationAccess:m,actions:d})=>{let{hasIntegrationPageRedesign:p,hasMobileFlows:h,hasAIAssistant:v,hasSubscription:k}=t,x=Ri.has(i),L=Bi.some(N=>typeof N=="string"?N===i:N.test(i)),M=Ei.has(i),b=Fi.some(N=>typeof N=="string"?N===i:N.test(i)),I=Wi.some(N=>typeof N=="string"?N===i:N.test(i)),ge=i.includes("/settings/emails/suppression-lists/"),de=i.startsWith("/settings/properties");return C(o.Wrapper,{children:[g(D,{user:n,onSpoof:a,isSpoofing:s}),C(jo,{children:[g(Zo,{onClick:r}),g(O,{})]}),g(ot.Root,{orientation:"vertical",children:g(ot.List,{children:v&&d?d:null})}),g(Qo,{size:"medium",weight:"semibold",children:"Settings"}),g(o.ScrollContainer,{children:g(o.Nav,{children:C(o.NavList,{children:[g(o.NavItem,{icon:ki,NavLink:e,to:"/settings/account",children:"Profile"}),g(o.NavItem,{icon:Ii,NavLink:e,to:"/settings/team",children:"Team"}),k&&g(o.NavItem,{icon:bi,NavLink:e,to:"/settings/subscription",children:"Subscription"}),g(o.NavItem,{icon:Ni,NavLink:e,to:"/settings/installation",isActive:b,children:h?"Apps & Installation":"Installation"}),g(o.NavItem,{icon:Ti,NavLink:e,to:"/settings/themes",isActive:L,children:"Themes"}),v&&g(o.NavItem,{icon:Ai,NavLink:e,to:"/settings/ai-assistant",children:"Appcues AI"}),C(o.NavAccordion,{text:"Emails",icon:xi,isActive:I,children:[g(o.NavItem,{NavLink:e,to:"/settings/emails/senders",children:"Senders"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/suppression-lists/unsubscribes",isActive:ge,children:"Suppression Lists"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/sending-behavior",children:"Sending Behavior"})]}),C(o.NavAccordion,{text:"Integrations",icon:yi,isActive:x,children:[g(o.NavItem,{NavLink:e,to:p?"/integrations/connections":"/settings/integrations",children:"Connections"}),g(o.NavItem,{NavLink:e,to:"/integrations/webhooks",children:"Webhooks"}),g(o.NavItem,{NavLink:e,to:"/settings/keys",children:"API Keys"})]}),C(o.NavAccordion,{text:"Data",icon:Li,isActive:M,children:[g(o.NavItem,{NavLink:e,to:"/settings/identifier",children:"Accounts & Users"}),g(o.NavItem,{NavLink:e,to:"/settings/events",children:"Events"}),g(o.NavItem,{NavLink:e,to:"/settings/properties/user",isActive:de,children:"Properties"})]}),m&&g(o.NavItem,{icon:wi,NavLink:e,to:"/settings/localization",children:"Localization"})]})})}),g(o.NavList,{children:g(et,{children:g(o.NavButton,{onClick:c,children:C(Ci,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[g(Mi,{colorToken:"foreground-primary",children:"Sign out "}),g(Pi,{colorToken:"foreground-secondary",size:"small",icon:Si})]})})})})]})};import Di from"styled-components";var nt=Di.div`
  flex: 0 0 220px;
  width: 220px;
  position: fixed;
  height: 100vh;
  background-color: var(--color-neutral-100);
  border-right: 1px solid var(--border-default);
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 100;
`;import{jsx as $i}from"react/jsx-runtime";var it=()=>$i(nt,{});import{useCallback as Oi,useEffect as Hi,useRef as zi}from"react";import{createPopup as Ui}from"@typeform/embed";var Gi={unmount:()=>{},open:()=>{}},_i="QD5X3rU2";function rt({size:e=60,formValues:t={}}){let i=zi(Gi);return Hi(()=>{let a={size:e,hidden:t};i.current=Ui(_i,a)},[i,e,t]),{handleClick:Oi(()=>i.current.open(),[i])}}import at from"styled-components";import{Link as Vi}from"@appcues/sonar";var st=at.span`
  --font-size-regular: var(--font-size-small);
  --foreground-link: var(--color-blurple-400);
  --link-text-decoration: none;
`,lt=at(Vi)``;import{jsx as pt}from"react/jsx-runtime";var ct=({children:e,message:t,subject:i,user:n,mailto:a="support@appcues.com",...s})=>{let r=(n==null?void 0:n.fullName)||(n==null?void 0:n.fullname),{email:c}=n!=null?n:{},m=["Hi,",t,"Thanks!"].join(`

`),d={message:t,subject:i,text:m,mailto:a,...r&&{name:r},...c&&{email:c}},{handleClick:p}=rt({formValues:d});return pt(st,{onClick:p,children:pt(lt,{"data-testid":"typeform-beacon",icon:!1,...s,children:e})})};import{Text as Ji}from"@appcues/sonar";import Ki from"styled-components";import{Link as mt}from"@appcues/sonar";import{Link as qi}from"react-router-dom";import{jsx as gt}from"react/jsx-runtime";var Xi=({children:e,href:t,...i})=>t?gt(mt,{href:t,...i,children:e}):gt(mt,{forwardedAs:qi,...i,children:e}),ce=Ki(Xi)``;import me from"styled-components";var Yi=me.div`
  align-items: center;
  background: white;
  box-shadow: var(--elevation-200);
  display: flex;
  height: 48px;
  justify-content: center;
`,sp=me.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 9000;
  min-width: 870px;
`,dt=me(Yi)`
  background: var(--color-pink-600);
  color: white;
  gap: var(--spacing-small);
`,ut=me.div``;import{jsx as Re,jsxs as ft}from"react/jsx-runtime";var Zi=()=>Re(ce,{colorToken:"white",href:"#",onClick:e=>{e.preventDefault()},children:"Stop spoofing"});function Qi({accountId:e,spoofing:t,onDespoof:i}){return t?ft(dt,{"aria-live":"polite",role:"alert",children:[ft(Ji,{weight:"bold",colorToken:"white",children:["Spoofing Account ",e]}),Re(ut,{onClick:i,children:Re(Zi,{})})]}):null}export{W as BannerIcon,ct as BeaconLink,it as BlankNavigation,ce as Link,Jo as MainNavigation,o as Navigation,tt as SettingsNavigation,Qi as SpoofBanner,be as isTrialAccount};
//# sourceMappingURL=index.mjs.map